import { createSelector } from 'reselect';
import get from 'lodash/get';

import { getProductById } from 'redux/modules/entities/selectors/products';

export const makeGetProductName = () =>
  createSelector([getProductById], product => get(product, 'name', null));

export const getProductName = makeGetProductName();

export const getProductReviews = createSelector([getProductById], product => product?.reviews);

export const productHasReviews = createSelector(
  getProductReviews,
  reviews => reviews?.reviewCount > 0,
);
